module.exports = require('./useCurrentLocale')
